import {Nullable, StockInformationType} from "../../definitions/types";

export class EmployeeNotificationBannerModel {
    private readonly _isOnline: boolean;
    private readonly _validated: boolean;
    private readonly _status: Nullable<string>;
    private readonly _hasValidStatus: boolean;

    constructor(isOnline: boolean, validated: boolean, stockInformation: Nullable<StockInformationType>) {
        this._isOnline = isOnline;
        this._validated = validated;
        this._status = stockInformation ? stockInformation.status : null;
        this._hasValidStatus = stockInformation ? stockInformation.hasValidStatus : false;
    }

    /**
     * @property isOnline
     * @description Whether the standalone product is online or the primary + variant product is online
     * @type {boolean}
     */
    public get isOnline(): boolean {
        return this._isOnline;
    }

    /**
     * @property validated
     * @description Whether the standalone product is validated or the primary + variant product is validated
     * @type {boolean}
     */
    public get validated(): boolean {
        return this._validated;
    }

    /**
     * @property status
     * @description The status of the standalone product or the primary + variant product
     * @type {Nullable<string>}
     */
    public get status(): Nullable<string> {
        return this._status;
    }

    /**
     * @property hasValidStatus
     * @description Whether the standalone product has a valid status or the primary + variant product has a valid status
     * @type {boolean}
     */
    public get hasValidStatus(): boolean {
        return this._hasValidStatus;
    }
}